import React from 'react';
import {useTranslation} from 'react-i18next';
import {ELEMENT} from '../../../../../incase-domain/elements/base/ElementTypes';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';
import {QuestionReport} from '../../../../../incase-domain/analytics';
import ReportAnswerPercentage from '../../../../../incase-domain/components/report/answer/ReportAnswerPercentage';
import ConfusionMatrix from '../../../../../incase-domain/components/report/answer/matchPair/confusionMatrix/ConfusionMatrix';
import {getAnswerStatus} from '../utils/reports';
import {useLayout} from '../../../../../hooks/useLayout';
import ReportAnswerMatchPair from '../../../../../incase-domain/components/report/answer/matchPair/ReportAnswerMatchPair';
import {usePresentationMode} from '../../../../../hooks/usePresentationMode';

interface AnswerDistributionProps {
    element: IElementQuestionnaire;
    questionReport?: QuestionReport;
    showCorrect?: boolean;
}

function AnswerDistribution({element, questionReport, showCorrect}: AnswerDistributionProps): JSX.Element | null {
    const {t} = useTranslation();
    const {type} = element;

    const {mobileView} = useLayout();
    const {isPresenter} = usePresentationMode();

    if (type === ELEMENT.LIKERT_SCALE) {
        return null;
    }

    const matchPairsReport = questionReport?.matchPairsReport;

    return (
        <div>
            <div className="question-report-modal__distribution-title">{t('report.answerDistribution')}</div>
            {type !== ELEMENT.MATCH_PAIR_QUESTION &&
                questionReport?.answers?.map((answer, index) => (
                    <div className="question-report-modal__answer-item" key={index}>
                        <ReportAnswerPercentage
                            key={index}
                            label={answer.answerText}
                            percentage={answer.percentage}
                            type={getAnswerStatus(answer, element, questionReport)}
                            showCorrect={showCorrect}
                            isPresenter={isPresenter}
                        />
                    </div>
                ))}
            {type === ELEMENT.MATCH_PAIR_QUESTION &&
                matchPairsReport &&
                (mobileView ? (
                    <ReportAnswerMatchPair matchPairReport={matchPairsReport} />
                ) : (
                    <ConfusionMatrix matchPairReport={matchPairsReport} showPercentages />
                ))}
        </div>
    );
}

export default AnswerDistribution;
